import {Component, inject, Input} from '@angular/core';
import {MemoryService} from '../../../../core/services/memory.service';
import {ReactiveFormsModule} from '@angular/forms';
import {MatFormFieldModule} from '@angular/material/form-field';
import {TextButton} from '../../../../shared/components/text-button/text-button.component';
import {AppointmentSelectionService} from '../../appointment-selection.service';
import {TranslocoPipe} from '@jsverse/transloco';
import {MatSelectModule} from '@angular/material/select';
import {MatInputModule} from '@angular/material/input';
import {Router} from '@angular/router';
import {LocalizedTextPipe} from '../../../../shared/pipes/localized-text.pipe';
import {MatIconModule} from '@angular/material/icon';

@Component({
  selector: 'app-appointment-filters',
  imports: [
    MatFormFieldModule,
    ReactiveFormsModule,
    TextButton,
    TranslocoPipe,
    MatSelectModule,
    MatInputModule,
    LocalizedTextPipe,
    MatIconModule
  ],
  templateUrl: './appointment-filters.component.html',
  styleUrl: './appointment-filters.component.scss'
})
export class AppointmentFiltersComponent {
  @Input() mobile = true;

  memoryService = inject(MemoryService);
  appointmentSelectionService = inject(AppointmentSelectionService);
  router = inject(Router);

  get employeeIds(): number[] | undefined {
    const employeeIds = this.appointmentSelectionService.employeeSummaryDtos?.map(e => e.employeeId);

    if (!employeeIds) {
      return undefined;
    }

    if (this.memoryService.locationDetailDto!.appearanceSettings.hideAnyTherapist) {
      return employeeIds;
    }

    return [0, ...employeeIds];
  }

  employeeName(employeeId: number): string | undefined {
    let employeeSummaryDto = this.appointmentSelectionService.employeeSummaryDtos?.find(e => e.employeeId === employeeId);

    if (!employeeSummaryDto) {
      return undefined;
    }

    return `${employeeSummaryDto?.firstName} ${employeeSummaryDto?.lastName}`;
  }

  employeeImageUrl(employeeId: number): string | undefined {
    let employeeSummaryDto = this.appointmentSelectionService.employeeSummaryDtos?.find(e => e.employeeId === employeeId);

    if (!employeeSummaryDto) {
      return undefined;
    }

    return employeeSummaryDto?.imageUrl!;
  }

  navigateToDateSelection() {
    this.appointmentSelectionService.appointmentFiltersForm?.markAllAsTouched()
    if (this.appointmentSelectionService.appointmentFiltersForm?.invalid) {
      return;
    }

    this.router.navigate(['/appointment-selection/date-selection']);
  }
}
